import React, { FC, useState } from 'react';
import { DateRangePicker } from 'react-dates';
import moment, { Moment } from 'moment';
import { Calendar } from '@assets/svg/icons';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './styles.scss';

interface IDateRange {
  dateStart: Moment | null;
  dateEnd: Moment | null;
  displayFormat?: string;
  endDatePlaceholderText?: string;
  icon?: JSX.Element;
  label?: string | JSX.Element;
  numberOfMonths?: number;
  startDatePlaceholderText?: string;
  variant?: 'dark' | 'light';
  endDateOffset?: (day: Moment) => Moment;
  startDateOffset?: (day: Moment) => Moment;
  onDateChange?: ({
    startDate,
    endDate,
  }: {
    startDate: Moment | null;
    endDate: Moment | null;
  }) => void;
}

const DateRange: FC<IDateRange> = ({
  dateStart,
  dateEnd,
  label,
  variant = 'dark',
  onDateChange,
  ...rest
}) => {
  const [focusedInput, setFocusedInput] = useState<null | 'startDate' | 'endDate'>(null);
  const [startState, setStartState] = useState<Moment | null>(dateStart);
  const [endState, setEndState] = useState<Moment | null>(dateEnd);

  return (
    <div className={`date-range-picker date-range-${variant}`}>
      {label && <div className="date-range-picker-label">{label}</div>}
      <DateRangePicker
        customArrowIcon={<>-</>}
        customInputIcon={<Calendar />}
        endDate={endState}
        endDateId="end-date"
        focusedInput={focusedInput}
        hideKeyboardShortcutsPanel
        inputIconPosition="after"
        readOnly
        startDate={startState}
        startDateId="start-date"
        isOutsideRange={(day) => moment().diff(day) < 0} // Allow past dates
        onDatesChange={({ startDate, endDate }) => {
          onDateChange?.({ startDate, endDate });
          setStartState(startDate);
          setEndState(endDate);
        }}
        onFocusChange={(arg) => setFocusedInput(arg)}
        {...rest}
      />
    </div>
  );
};

export default DateRange;
